import type { UiMessages } from "../types";

export const nl: UiMessages = {
  nav: {
    streams: "Streams",
    videos: "Video's",
    shorts: "Shorts",
    forYou: "Voor jou",
    vr: "VR",
    cartoon: "Cartoon",
    hentai: "Hentai",
    sections: "Meer",
    menu: "Menu",
    game: "Seksspel",
    stories: "Seksverhalen",
    escorts: "Escorts",
    ai: "AI-vriendinnen",
    paysites: "Premium-sites",
    home: "Home",
    following: "Volgend",
    watching: "Geschiedenis",
    rankings: "Ranglijst",
    invite: "Vrienden uitnodigen",
    coins: "Sweet Coin",
    achievements: "Prestaties",
    hot: "Nu populair",
    random: "Willekeurige video",
    saved: "Opgeslagen",
    reacted: "Geliket",
    boost: "Sweet Boost",
    premium: "Premium",
    stars: "Pornosterren",
    productions: "Studio's",
    categories: "Categorieën",
    telegram: "Telegramkanaal",
    allSections: "Alle secties",
    mainNavigation: "Hoofdnavigatie",
    quickNavigation: "Snelle navigatie",
    show: "Tonen",
    coinsReady: "Sweet Coins klaar om op te halen",
    logIn: "Inloggen",
    search: "Zoeken",
    closeSearch: "Zoeken sluiten",
    language: "Taal",
    theme: "Thema",
    themeDark: "Donker",
    themeLight: "Licht",
  },
  age: {
    parents: "Ouders: onze pagina {link} legt uit hoe je de toegang tot deze site blokkeert. Sweet heeft het RTA-label.",
    parentalControls: "ouderlijk toezicht",
    title: "Dit is een website voor volwassenen",
    body: "Deze website bevat materiaal met een leeftijdsgrens, waaronder naaktheid en expliciete beelden van seksuele handelingen. Door verder te gaan bevestig je dat je minstens 18 jaar oud bent, of meerderjarig volgens de wet van het land van waaruit je de website bezoekt, en dat je ermee instemt seksueel expliciete inhoud te bekijken.",
    enter: "Ik ben 18 of ouder — Doorgaan",
    exit: "Ik ben jonger dan 18 — Verlaten",
  },
  consent: {
    title: "Cookies",
    body: "Sweet is gratis dankzij advertenties. Onze advertentiepartners gebruiken cookies om ze te tonen en om hun weergaven en klikken te tellen. Noodzakelijke opslag, zoals je leeftijdsbevestiging, werkt hoe dan ook.",
    privacy: "Privacybeleid",
    acceptAll: "Alles accepteren",
    onlyNecessary: "Alleen noodzakelijke",
    settings: "Cookie-instellingen",
  },
  ago: { now: "nu", m: "{n} min", h: "{n} u", d: "{n} d", w: "{n} w", mo: "{n} mnd", y: "{n} j" },
  cams: {
    allPlatforms: "Alle platforms",
    watchOnSite: "Bekijk op {site}",
    liveFor: "al {time} live",
    tryAnother: "Probeer een andere tag of regio, of kom over een tijdje terug.",
    nobodyLiveOn: "Er is nu niemand live op {name}",
    platformShowUpHint: "Streams van {name} verschijnen hier zodra ze beginnen. Kom over een tijdje terug.",
    liveNowCount: "{n} nu live",
    opensOn: "ze openen op {site}",
    streamerSite: "de site van de streamer",
    orWatch: "Of bekijk {link}.",
    videoTag: "#{tag}-video's",
    liveStreams: "Livestreams",
    platformStreams: "{name} livestreams",
    liveCams: "Live cams",
    platformCams: "{name} cams",
    moreLiveCams: "Meer live cams",
    byTopic: "Live cams per thema",
    breadcrumb: "Kruimelpad",
    live: "Live",
    viewers: "Kijkers:",
    isLive: "{name} is live",
    watchOn: "{title} — kijk live op {site}",
    nobodyLive: "Er is nu niemand live",
    noMatch: "Geen livestreams die bij deze filters passen",
    showUpHint: "Streams verschijnen hier zodra ze beginnen. Kom over een tijdje terug.",
    clearFilters: "Filters wissen",
    clearAll: "Alles wissen",
    clear: "Wissen",
    seeAllPlatforms: "Alle platforms bekijken",
    watchVideos: "Video's bekijken",
    onPlatform: " op {name}",
    newOnTelegram: "Nieuwe live cams op Telegram",
    loadMoreFailed: "Meer laden mislukt — probeer het opnieuw",
    platforms: "Platforms",
    streamPlatforms: "Streamplatforms",
    platformsAndFilters: "Streamplatforms en filters",
    categories: "Categorieën",
    all: "Alle",
    region: "Regio",
    allRegions: "Alle regio's",
    more: "Meer",
    newModels: "Nieuwe modellen",
    tags: "Tags",
    removeTag: "Tag verwijderen",
    remove: "Verwijderen",
    loading: "Laden",
    offline: "Offline",
    seeAll: "Alles bekijken",
    genders: { female: "Vrouwen", male: "Mannen", couple: "Koppels", trans: "Trans" },
    regions: { north_america: "Noord-Amerikaans", south_america: "Zuid-Amerikaans", europe: "Europees & Russisch", asia: "Aziatisch", other: "Andere regio's" },
  },
  video: {
    fullScene: "Bekijk de volledige scène op {site}",
    upNext: "Hierna",
    nextPage: "Volgende pagina",
    moreVideos: "Meer video's",
    end: "Je bent bij het einde.",
    loadMoreFailed: "Meer laden mislukt — probeer het opnieuw",
    likes: "Likes",
    premiumVideo: "Premium-video",
    subscribeToWatch: "Neem een abonnement om deze video helemaal te bekijken.",
    getPremium: "Neem Premium",
    logIn: "Inloggen",
    playsIn: "Speelt af in de speler van {name}",
    partnerBlocked: "De video speelt af vanaf de servers van {name}, en die zijn vanaf je netwerk niet bereikbaar: {name} is misschien geblokkeerd door je provider of in je land.",
    unavailable: "{name} speelt zijn video's niet af in jouw land, dus deze kun je hier niet bekijken.",
    watchCams: "Bekijk liever live cams",
    chatLive: "Chat live met {name} op {site}",
    play: "{title} afspelen",
    sponsored: "Gesponsord",
    onlyfansCreators: "OnlyFans-makers",
    liveNowFree: "Nu live · gratis",
    allVideos: "Alle video's",
    stoppedAt: "Gestopt bij {at} van {of}",
    watchedToEnd: "Tot het einde bekeken",
  },
  profile: { followers: "Volgers", views: "Weergaven", videos: "Video's", verified: "Geverifieerd", follow: "Volgen", unfollow: "Ontvolgen" },
  lists: {
    categories: "Categorieën",
    popular: "Populair",
    aToZ: "A – Z",
    jumpToLetter: "Spring naar letter",
    allCategories: "Alle categorieën",
    noVideosYet: "Hier zijn nog geen video's",
    pageN: "Pagina {n}",
    newEveryDay: "Elke dag komen er nieuwe video's bij.",
    videoCount: "{n} video's",
    pornstars: "Pornosterren",
    pornstarsIntro: "De meest gevolgde makers van deze week.",
    studios: "Pornostudio's",
    studiosIntro: "Productiebedrijven en kanalen, gerangschikt op volgers.",
    noVideosWithTag: "Geen video's met deze tag",
    showAllVideos: "Alle video's tonen",
  },
  hot: {
    title: "Nu populair",
    intro: "De meest bekeken video's op Sweet van de afgelopen uren.",
  },
  comments: {
    title: "Reacties",
    placeholder: "Schrijf een reactie…",
    post: "Plaatsen",
    login: "Log in om te reageren",
    coinsHint: "+{n} munten voor elk van je eerste {max} reacties per dag",
    earned: "+{n} munten",
    empty: "Nog geen reacties. Wees de eerste.",
    more: "Meer tonen",
    delete: "Verwijderen",
    short: "Schrijf iets meer.",
    long: "Dat is te lang: maximaal {n} tekens.",
    links: "Links en contactgegevens zijn niet toegestaan in reacties.",
    forbidden: "Deze reactie kan niet worden geplaatst.",
    rate: "Je reageert te snel. Probeer het later opnieuw.",
    duplicate: "Dit heb je al geplaatst.",
    failed: "Plaatsen is niet gelukt. Probeer het opnieuw.",
    like: "Vind ik leuk",
    dislike: "Vind ik niet leuk",
    rateLogin: "Log in om video's te beoordelen",
    liked: "{p}% vindt het leuk",
  },
  starVote: {
    title: "Ster van de maand",
    vote: "Stemmen",
    voteFor: "Stem op {name} als ster van de maand",
    voteAgain: "Nog eens stemmen · {n} munten",
    confirm: "{n} munten uitgeven?",
    standing: "#{rank} deze maand · stemmen: {n}",
    noVotes: "Deze maand nog geen stemmen",
    thanks: "Bedankt voor je stem!",
    paidThanks: "Stem geteld · −{n} munten",
    coins: "Niet genoeg munten: een stem kost {n}.",
    limit: "Dat waren al je stemmen voor vandaag.",
    rules: "Eén gratis stem per dag, daarna {n} munten per stem.",
    boardIntro: "Leden stemmen op de pagina's van de sterren op hun favorieten: één gratis stem per dag, meer voor {n} munten per stem.",
    boardEmpty: "Deze maand nog geen stemmen. Ga naar de pagina van een ster om te stemmen.",
    votes: "Stemmen",
    lastWinner: "Ster van vorige maand",
    login: "Log in om te stemmen",
  },
  achievements: {
    title: "Prestaties",
    intro: "Ontgrendel prestaties terwijl je kijkt, volgt en meedoet. Elke prestatie levert Sweet Coins op.",
    unlocked: "Ontgrendeld",
    coins: "+{n} munten",
    progress: "{x} van {n}",
    total: "{x} van {n} ontgrendeld",
    login: "Log in om prestaties en hun munten te verzamelen.",
    signup: "Account aanmaken",
    toast: "Prestatie ontgrendeld",
    names: {
      "videos-1": ["Eerste video", "Bekijk je eerste video"],
      "videos-10": ["Opgewarmd", "Bekijk 10 video's"],
      "videos-100": ["Vaste kijker", "Bekijk 100 video's"],
      "videos-1000": ["Kenner", "Bekijk 1.000 video's"],
      "hours-1": ["Eerste uur", "Kijk een uur lang"],
      "hours-10": ["Tien uur", "Kijk 10 uur lang"],
      "hours-100": ["Marathon", "Kijk 100 uur lang"],
      "streak-3": ["Drie op rij", "Kijk 3 dagen achter elkaar"],
      "streak-7": ["Weekreeks", "Kijk een week lang elke dag"],
      "streak-30": ["Maandreeks", "Kijk 30 dagen lang elke dag"],
      "follows-5": ["Fan", "Volg 5 sterren of studio's"],
      "likes-25": ["Groot hart", "Like 25 video's"],
      "saves-10": ["Verzamelaar", "Sla 10 video's op"],
      "days-7": ["Muntenweek", "Haal op 7 dagen munten op"],
      "days-30": ["Muntenmaand", "Haal op 30 dagen munten op"],
      "invites-1": ["Neem een vriend mee", "Nodig een vriend uit die zich aanmeldt"],
      "comments-1": ["Eerste woorden", "Schrijf je eerste reactie"],
      "comments-25": ["Kletskous", "Schrijf 25 reacties"],
      "votes-1": ["Kiezer", "Stem op een ster van de maand"],
    },
  },
  pwa: {
    appName: "Sweet-app",
    bannerLabel: "Installeer de app",
    bannerPitch: "Volledig scherm, zonder app store",
    install: "Installeren",
    notNow: "Niet nu",
    installApp: "Installeer de app",
    howToInstall: "Zo installeer je de app",
    inApp: "Je gebruikt de app.",
    cardPitch: "Volledig scherm, met één tik vanaf je beginscherm. Geen app store nodig.",
    manual: "Open het browsermenu en kies {install} of {add}.",
    iosTitle: "Zet Sweet op je beginscherm",
    iosShare: "Tik op {share} in de browserbalk (op iOS 26: {more}, dan {share})",
    iosAdd: "Kies {add}",
    iosConfirm: "Tik op {confirm}: Sweet opent op volledig scherm vanaf je beginscherm",
    share: "Deel",
    more: "•••",
    add: "Zet op beginscherm",
    confirm: "Voeg toe",
    installMenu: "App installeren",
    gotIt: "Begrepen",
    close: "Sluiten",
    offlineTitle: "Je bent offline",
    offlineBody: "Sweet heeft internet nodig om video's en cams af te spelen. Controleer je verbinding en probeer het opnieuw.",
    retry: "Opnieuw proberen",
    recent: "Onlangs geopend",
  },
  notifications: {
    title: "Meldingen",
    empty: "Nog niets nieuws. Volg sterren en studio's, of voeg cammodellen toe aan je favorieten, en hun nieuws verschijnt hier.",
    newVideos: "Nieuwe video's",
    liveNow: "Nu live",
    markRead: "Alles als gelezen markeren",
    pushOn: "Meldingen aanzetten",
    pushOff: "Meldingen uitzetten",
    pushHint: "Krijg een seintje bij nieuwe video's en favorieten die live gaan, ook als Sweet gesloten is.",
    pushBlocked: "Meldingen voor Sweet zijn geblokkeerd in de instellingen van je browser.",
    pushUnsupported: "Deze browser kan geen meldingen tonen. Zet Sweet op een iPhone eerst op je beginscherm.",
    pushEnabled: "Meldingen staan aan",
    favorites: "Favoriete modellen",
    addFavorite: "Toevoegen aan favorieten",
    removeFavorite: "Verwijderen uit favorieten",
    favoritesEmpty: "Nog geen favoriete modellen. Tik op het hartje bij een cam om er een toe te voegen.",
    offline: "Offline",
    viewAll: "Alles bekijken",
  },
  forYou: {
    title: "Voor jou",
    all: "Alle",
    continueWatching: "Verder kijken",
    intro: "Gekozen op basis van wat je liket, opslaat, bekijkt en volgt.",
    empty: "Like, bewaar of volg een paar video's en sterren, en hier verschijnen video's die voor jou zijn uitgekozen.",
    more: "Meer",
  },
  shorts: {
    straight: "Hetero",
    gay: "Gay",
    trans: "Trans",
    watchFull: "Volledige video bekijken",
    like: "Vind ik leuk",
    liked: "Geliket",
    save: "Opslaan",
    saved: "Opgeslagen",
    share: "Delen",
    copied: "Link gekopieerd",
    soundOn: "Geluid aan",
    soundOff: "Geluid uit",
    tapForSound: "Tik voor geluid",
    report: "Melden",
    follow: "Volgen",
    following: "Volgend",
    previous: "Vorige",
    next: "Volgende",
    close: "Sluiten",
    end: "Dat was het voor nu. Meer bij Video's.",
    empty: "Hier zijn nog geen shorts.",
    live: "Live",
    watchLive: "Gratis live kijken",
    watching: "{n} kijken",
    profile: "Profiel",
    moreLive: "Meer live cams",
  },
  search: {
    searches: "Zoekopdrachten",
    popular: "Populaire zoekopdrachten",
    categories: "Categorieën",
    searchFor: "Zoek video's met “{q}”",
    nothingFor: "Niets gevonden voor “{q}”.",
    title: "Zoeken op Sweet",
    placeholder: "Zoek video's, mensen en merken",
    hint: "Vind video's, sterren, producties en categorieën. Druk overal op / om te beginnen met typen.",
    stars: "Sterren",
    productions: "Producties",
    other: "Overig",
    otherProfiles: "Andere profielen",
    nothing: "Niets gevonden",
    tryAgain: "Controleer de spelling of probeer een algemenere zoekterm.",
    backHome: "Terug naar home",
  },
  notFound: { title: "Deze pagina bestaat niet", body: "De video is misschien verwijderd, of er zit een typfout in de link.", home: "Naar home" },
  common: {
    close: "Sluiten",
    copy: "Kopiëren",
    copied: "Gekopieerd",
    more: "Meer",
    loading: "Laden",
    clearAll: "Alles wissen",
    browseVideos: "Video's bekijken",
    scrollLeft: "Naar links scrollen",
    scrollRight: "Naar rechts scrollen",
  },
  actions: {
    react: "Vind ik leuk",
    reacted: "Geliket",
    save: "Opslaan",
    saved: "Opgeslagen",
    follow: "Volgen",
    following: "Volgend",
    followName: "{name} volgen",
    unfollowName: "{name} ontvolgen",
    moreOptions: "Meer opties",
    share: "Delen",
    copyLink: "Link kopiëren",
    linkCopied: "Link gekopieerd",
    report: "Melden",
    home: "Sweet — home",
    onSweet: "{name} op Sweet",
    joinMe: "Kom ook naar Sweet",
    inviteLink: "Je uitnodigingslink",
  },
  library: {
    savedEmpty: "Nog niets opgeslagen",
    savedHint: "Tik op de bladwijzer onder een video om hem hier te bewaren. Je lijst wordt alleen op dit apparaat opgeslagen.",
    reactedEmpty: "Nog niets geliket",
    reactedHint: "Video's die je een hartje geeft verschijnen hier, de nieuwste eerst.",
    watchingEmpty: "Nog niets bekeken",
    watchingHint: "Video's die je afspeelt verschijnen hier met het precieze moment waarop je stopte, en gaan daar verder als je ze opnieuw opent.",
    removeWatching: "Verwijderen uit Geschiedenis",
    removeVideo: "{title} verwijderen uit Geschiedenis",
    followingEmpty: "Je volgt nog niemand",
    followingHint: "Tik op de + bij een maker of studio en hun nieuwste video's verzamelen zich hier. Wie je volgt, wordt alleen op dit apparaat opgeslagen.",
    discoverModels: "Ontdek modellen",
    noVideosHint: "Probeer een andere categorie — er komen elke dag nieuwe video's bij.",
    backToAll: "Terug naar alle video's",
  },
  player: {
    resumesAt: "Gaat verder bij {at}",
    startOver: "Opnieuw beginnen",
    unavailable: "Deze video is nu niet beschikbaar.",
    play: "Afspelen",
    pause: "Pauzeren",
    seek: "Spoelen",
    back10: "10 seconden terug",
    forward10: "10 seconden vooruit",
    mute: "Dempen",
    unmute: "Geluid aan",
    volume: "Volume",
    settings: "Instellingen",
    pip: "Beeld-in-beeld",
    fullscreen: "Volledig scherm",
    exitFullscreen: "Volledig scherm sluiten",
    quality: "Kwaliteit",
    speed: "Afspeelsnelheid",
    normal: "Normaal",
    auto: "Auto",
    partner: "de partner",
  },
  ads: { ad: "Advertentie", advertisement: "Advertentie", muteAd: "Advertentie dempen", unmuteAd: "Geluid advertentie aan", skipIn: "Overslaan over {n}", skipAd: "Advertentie overslaan ›" },
  auth: {
    username: "Gebruikersnaam",
    usernameOrEmail: "Gebruikersnaam of e-mail",
    emailOptional: "E-mail (optioneel)",
    password: "Wachtwoord",
    currentPassword: "Huidig wachtwoord",
    newPassword: "Nieuw wachtwoord",
    confirmPassword: "Bevestig wachtwoord",
    confirmNewPassword: "Bevestig nieuw wachtwoord",
    showPassword: "Wachtwoord tonen",
    hidePassword: "Wachtwoord verbergen",
    forgot: "Wachtwoord vergeten?",
    remember: "Ingelogd blijven",
    logIn: "Inloggen",
    createAccount: "Account aanmaken",
    usernameHelp: "3–24 letters, cijfers, punten of underscores. Zichtbaar in de ranglijst.",
    emailHelp: "Alleen gebruikt om je wachtwoord te resetten. Je kunt het later in je account toevoegen.",
    passwordHelp: "Minstens 8 tekens.",
    adult: "Ik ben 18 jaar of ouder.",
    agree: "Ik ga akkoord met de {terms} en het {privacy}.",
    terms: "Voorwaarden",
    privacy: "Privacybeleid",
    savePhrasesTitle: "Bewaar je herstelzinnen",
    savePhrasesBody: "Je hebt je aangemeld zonder e-mail, dus met deze zinnen kom je weer binnen als je je wachtwoord vergeet.",
    continue: "Doorgaan",
    resetHow: "Zo reset je je wachtwoord",
    byEmail: "Stuur me een link",
    byPhrase: "Gebruik een herstelzin",
    phraseIntro: "Voor accounts zonder e-mail: vul je gebruikersnaam in en een van de herstelzinnen die je bij het aanmelden hebt bewaard.",
    phrase: "Herstelzin",
    phrasePlaceholder: "woord woord woord woord",
    phraseHelp: "De 4 woorden van één zin. Elke zin werkt één keer.",
    saveNewPassword: "Nieuw wachtwoord opslaan",
    sendLink: "Resetlink versturen",
  },
  phrases: {
    warning: "Bewaar ze nu: ze worden niet nog een keer getoond. Als je je wachtwoord vergeet, kies je met je gebruikersnaam en een van deze zinnen een nieuw wachtwoord. Elke zin werkt één keer. Houd ze geheim.",
    list: "Je herstelzinnen",
    copyAll: "Alles kopiëren",
    download: ".txt downloaden",
    savedCheck: "Ik heb mijn herstelzinnen op een veilige plek bewaard.",
    done: "Klaar",
    fileTitle: "Sweet-herstelzinnen voor @{username}",
    fileHow: "Als je je wachtwoord vergeet, ga dan naar {url}, kies “{option}” en vul je gebruikersnaam en een van deze zinnen in.",
    filePrivate: "Elke zin werkt één keer. Houd ze geheim: iedereen met je gebruikersnaam en een van deze zinnen kan je account overnemen.",
    none: "Je account heeft geen e-mail en geen herstelzinnen. Als je je wachtwoord vergeet, kom je er niet meer in. Maak nu herstelzinnen aan.",
    optional: "Met herstelzinnen kies je zonder e-mail een nieuw wachtwoord. Optioneel zolang je account een e-mailadres heeft.",
    left: "{left} van {total} zinnen ongebruikt.",
    leftMade: "{left} van {total} zinnen ongebruikt, aangemaakt op {date}.",
    how: "Met elke zin kun je, samen met je gebruikersnaam, één keer een nieuw wachtwoord kiezen. Kwijt? Maak nieuwe aan, dan werken de oude niet meer.",
    make: "Herstelzinnen aanmaken",
    makeNew: "Nieuwe zinnen aanmaken",
  },
  account: {
    menu: "Accountmenu",
    settings: "Accountinstellingen",
    profiles: "Je profielen",
    logOut: "Uitloggen",
    uploadPhoto: "Foto uploaden",
    removePhoto: "Huidige foto verwijderen",
    displayName: "Weergavenaam",
    showInRankings: "Toon mij in de ranglijst",
    rankingsHelp: "Je naam, foto en kijkstatistieken verschijnen in de openbare {link}. Zet dit uit als je er niet in wilt staan; je kijktijd wordt nog steeds geteld.",
    save: "Opslaan",
    emailHelp: "Alleen gebruikt om je een link te sturen als je je wachtwoord vergeet. Laat het leeg om het te verwijderen.",
    saveEmail: "E-mail opslaan",
    changePassword: "Wachtwoord wijzigen",
    deleteWarning: "Hiermee worden je account, opgeslagen video's, likes en wie je volgt definitief verwijderd. Dit kan niet ongedaan worden gemaakt.",
    typeToConfirm: "Typ {word} om te bevestigen",
    deleteMine: "Mijn account verwijderen",
  },
  pay: {
    billingPeriod: "Factuurperiode",
    monthly: "Maandelijks",
    yearly: "Jaarlijks",
    yourPlan: "Jouw pakket",
    month: "maand",
    year: "jaar",
    oneMonth: "1 maand",
    months: "{n} maanden",
    oneYear: "1 jaar",
    years: "{n} jaar",
    perMonth: "{price} per maand",
    save: "Bespaar {n}%",
    comingSoon: "Binnenkort",
    reward: "−{n}% jouw beloning",
    plays: "{n} potjes Sweet Room",
    addedAtOnce: "Direct bijgeschreven",
    get: "Neem {plan}",
    addMonth: "Maand erbij",
    addYear: "Jaar erbij",
    opensSoon: "Betalingen starten binnenkort",
    alreadyMember: "Al lid?",
    choose: "Kies hoe je betaalt",
    payWith: "Betalen met",
    starsInBot: "{n} Stars in onze Telegram-bot",
    card: "Kaart",
    crypto: "Crypto",
    cryptoMore: "BTC, USDT, ETH, TON en 30+ andere",
    tooManyStars: "Te veel voor één betaling met Telegram Stars.",
    cardMin: "Kaartbetalingen vanaf {price}.",
    payStars: "Betalen met Telegram Stars",
    preparing: "Je betaling wordt voorbereid…",
    loginFirst: "Log eerst in",
    cantStart: "Betaling kan niet starten",
    noAdsCoins: "Geen advertenties + {n} Sweet Coins",
    addedOnPay: "Bijgeschreven op je saldo zodra je betaalt",
    payInTelegram: "Betalen in Telegram",
    waitingStars: "Wachten op je betaling — deze pagina werkt zichzelf bij",
    allSet: "Helemaal klaar!",
    noAds: "Geen advertenties meer.",
    noAdsUntil: "Geen advertenties tot {date}.",
    coinsAdded: "{n} munten staan op je saldo.",
    startWatching: "Begin met kijken",
    great: "Top",
    payCard: "Betalen met kaart",
    failedTitle: "De betaling is niet gelukt",
    failedBody: "Er is niets afgeschreven. Je kunt het opnieuw proberen.",
    newTab: "Betaal in het nieuwe tabblad",
    newTabBody: "Kaart, Apple Pay of Google Pay, op de beveiligde pagina van Chain2Pay. Deze pagina werkt zichzelf bij zodra er betaald is.",
    waiting: "Wachten op je betaling…",
    openAgain: "Betaalpagina opnieuw openen",
    somethingWrong: "Er ging iets mis. Probeer het over een minuut opnieuw.",
    offline: "Je lijkt offline te zijn. Probeer het over een minuut opnieuw.",
    bestValue: "Beste deal",
    coins: "munten",
    orStars: "of {n} Stars",
    packsSoon: "Muntenpakketten zijn binnenkort te koop.",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coins opgehaald!",
    collectedToday: "Vandaag opgehaald",
    nextBonus: "Volgende bonus over",
    collecting: "Ophalen…",
    collect: "Haal {n} Sweet Coins op",
    alreadyCollected: "Je hebt de munten van vandaag al opgehaald. Kom morgen terug.",
    offerLabel: "Sweet Coins en Premium",
    offerTitle: "Haal Sweet Coins",
    offerFor: "Voor Sweet Room en betaalde video's",
    premiumFrom: "Premium vanaf {price}",
    upTo: "Geen advertenties + tot {n} munten",
    packsFrom: "Muntenpakketten vanaf {price}",
    collectFree: "Of haal elke dag gratis munten op",
    offerButton: "Sweet Coins-aanbieding",
    guestCollected: "+{n} Sweet Coins! Wil je je munten niet kwijtraken, registreer je dan bij Sweet.",
    guestKeep: "Zonder account worden munten {days} dagen bewaard en vervallen ze daarna.",
    guestSignup: "Gratis registreren en ze houden",
    guestLogin: "Al een account? Inloggen",
    guestExpire: "{n} munten vervallen op {date}.",
    guestUnsaved: "Je munten zijn nog niet bewaard: registreer je om ze te houden",
    guestExpiring: "{n} van je Sweet Coins vervallen binnen een dag. Registreer je gratis om ze te houden.",
  },
  footer: {
    copyright: "Auteursrecht",
    takedown: "Verwijderverzoek",
    contact: "Contact",
    creators: "Makers",
    claim: "Claim je profiel",
    webmasters: "Webmasters",
    terms: "Voorwaarden",
    privacy: "Privacy",
    info: "Info over de site",
    telegram: "{site} op Telegram",
  },
  report: {
    heading: "Een video melden",
    reason: "Reden",
    takedown: "Auteursrecht / DMCA",
    abuse: "Ik sta zonder mijn toestemming in deze video",
    minor: "Iemand in deze video is mogelijk jonger dan 18",
    other: "Iets anders",
    url: "Videolink of ID",
    email: "Je e-mailadres",
    details: "Details",
    detailsPlaceholder: "Wat moeten we verwijderen en waarom?",
    send: "Melding versturen",
  },
};
